import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/database'

// The configuration below is not sensitive data. You can serenely add your config here
const config = {
  apiKey: 'AIzaSyAkftVd8h1fMNrJS7IrXB-y32NyrGTP-rI',
  authDomain: 'canvas-forms.firebaseapp.com',
  databaseURL: 'https://canvas-forms.firebaseio.com',
  projectId: 'canvas-forms',
  storageBucket: 'canvas-forms.appspot.com',
  messagingSenderId: '637244991416',
  appId: '1:637244991416:web:c7e585ff725248c7fad14d',
  measurementId: 'G-L0N6L7FSWY',
}

export const db = firebase.initializeApp(config).firestore()
const { TimeStamp, GeoPoint } = firebase.firestore
export { TimeStamp, GeoPoint }
export const rdb = firebase.database()
